/**
 * @file video相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 获取视频元信息
 * @returns Promise
 */
export const getVideoMetaInfo = async api => {
    return request(api, {
        method: 'GET'
    });
};
/**
 * 获取图片元信息
 * @returns Promise
 */
export const getImageInfo = async api => {
    return request(api, {
        method: 'GET'
    });
};

/**
 * 生成视频
 * @returns Promise
*/
export const createVideo = async params => {
    return request(
        API.CREATE_VIDEO, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 取消生成视频
 * @returns Promise
*/
export const cancelVideo = async params => {
    return request(
        API.CANCEL_VIDEO, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 生成视频是否可投放
 * @returns Promise
*/
export const checkCanVideoPush = async params => {
    return request(
        API.CHECK_VIDEO_CAN_PUSH, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 投放视频
 * @returns Promise
*/
export const pushVideo = async params => {
    return request(
        API.VIDEO_PUSH, {
            method: 'POSTJSON',
            body: params
        }
    );
};
